import axiosInstance from './axiosConfig';
import type {
  CreateTemplatePayload,
  CreateTemplateResponse,
  TemplateDoc,
  UpdateTemplateBody,
  TemplateListItem,
} from '../interfaces';
import { ApiResult } from './generalService';

export const fetchTemplates = () =>
  axiosInstance.get<
    ApiResult<TemplateListItem[] | { templates: TemplateListItem[] }>
  >('/templates');

export const fetchTemplateById = (id: string) =>
  axiosInstance.get<ApiResult<TemplateDoc>>(`/templates/${id}`);

export const createTemplate = (payload: CreateTemplatePayload) =>
  axiosInstance.post<ApiResult<CreateTemplateResponse>>('/templates', payload);

export const updateTemplate = (id: string, payload: UpdateTemplateBody) =>
  axiosInstance.put<ApiResult<TemplateDoc>>(`/templates/${id}`, payload);

export const deleteTemplate = (id: string) =>
  axiosInstance.delete(`/templates/${id}`);
